export default "__VITE_ASSET__$Y8$HRS2__"